import { render, staticRenderFns } from "./ProofListPage.vue?vue&type=template&id=0f4dd2f0&"
import script from "./ProofListPage.vue?vue&type=script&lang=js&"
export * from "./ProofListPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports